import React from 'react';

export default {
  cities: [
    {
      id: 1,
      type: 1,
      name: "Ostrava",
      street: "Velká 17",
      zip: "702 00",
      city: "Ostrava - Moravská Ostrava",
      tel: "+420 596 114 647",
      mobile: "+420 731 443 366",
      fax: "+420 596 125 758",
      email: "ostrava@llc.cz",
      opening: {
        mo: "7:00 - 18:00",
        tu: "8:00 - 18:00",
        we: "7:00 - 18:00",
        th: "8:00 - 18:00",
        fr: "8:00 - 15:00"
      },
      opening_holidays: {
        mo: "7:00 - 18:00",
        tu: "8:30 - 18:00",
        we: "7:00 - 16:00",
        th: "7:00 - 15:00",
        fr: "7:00 - 14:00"
      },
      mapLat: 49.8344274,
      mapLng: 18.2900625,
      mapIframe: <iframe id="gmap_canvas" src="https://maps.google.com/maps?q=Velk%C3%A1%2017%20702%2000%20Ostrava%20-%20Moravsk%C3%A1%20Ostrava&t=&z=15&ie=UTF8&iwloc=&output=embed" frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0"/>,
      video: "MNKu-Q_mIck",
      bgImg: 1
    },
    {
      id: 2,
      type: 1,
      name: "Olomouc",
      street: "Litovelská 26",
      zip: "779 00",
      city: "Olomouc - Šibeník",
      tel: "+420 585 423 411",
      mobile: "+420 731 613 382",
      fax: "+420 585 429 461",
      email: "olomouc@llc.cz",
      opening: {
        mo: "8:00 - 18:00",
        tu: "8:00 - 18:00",
        we: "8:00 - 18:00",
        th: "8:00 - 18:00",
        fr: "8:00 - 15:00"
      },
      opening_holidays: {
        mo: "8:00 - 16:00",
        tu: "8:00 - 18:00",
        we: "8:00 - 16:00",
        th: "8:00 - 16:00",
        fr: "8:00 - 14:00"
      },
      mapLat: 49.5967781,
      mapLng: 17.2353612,
      mapIframe: <iframe id="gmap_canvas" src="https://maps.google.com/maps?q=Litovelsk%C3%A1%2026%20779%2000%20Olomouc%20-%20%C5%A0iben%C3%ADk&t=&z=15&ie=UTF8&iwloc=&output=embed" frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0"/>,
      video: "E3Df3f9SkCs",
      bgImg: 2
    },
    {
      id: 3,
      type: 1,
      name: "Opava",
      street: "Sady Svobody 4",
      zip: "746 01",
      city: "Opava",
      tel: "+420 552 301 552",
      mobile: "+420 603 488 038",
      email: "opava@llc.cz",
      opening: {
        mo: "9:00 - 18:00",
        tu: "9:00 - 18:00",
        we: "9:00 - 18:00",
        th: "9:00 - 18:00",
        fr: "9:00 - 16:00"
      },
      opening_holidays: {
        mo: "9:00 - 18:00",
        tu: "9:00 - 16:00",
        we: "9:00 - 16:00",
        th: "9:00 - 16:00",
        fr: "9:00 - 14:00"
      },
      mapLat: 49.9360396,
      mapLng: 17.9003353,
      mapIframe: <iframe id="gmap_canvas" src="https://maps.google.com/maps?q=Sady%20Svobody%204%20746%2001%20Opava&t=&z=15&ie=UTF8&iwloc=&output=embed" frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0"/>,
      video: "Q5X5qcDD4Bw",
      bgImg: 3
    },
    {
      id: 4,
      type: 2,
      name: "Frýdek - Místek",
      street: "v prostorách Polikliniky - Místek, 8. pěšího pluku 85",
      zip: "738 01",
      city: "Frýdek - Místek",
      tel: "+420 604 374 468",
      openingAlt: "Konzultační hodiny dle objednávky",
      mapLat: 49.677023,
      mapLng: 18.3402303,
      mapIframe: <iframe id="gmap_canvas" src="https://maps.google.com/maps?q=v%20prostor%C3%A1ch%20Polikliniky%20-%20M%C3%ADstek%2C%208.%20p%C4%9B%C5%A1%C3%ADho%20pluku%2085%20738%2001%20Fr%C3%BDdek%20-%20M%C3%ADstek&t=&z=15&ie=UTF8&iwloc=&output=embed" frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0"/>,
      bgImg: 4
    },
  ]
}



// WEBPACK FOOTER //
// ./src/texts/general/branches.js